/**
 * @generated SignedSource<<daaa461f3d5d941b1254bad8635cc109>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PageContentRenderer_space$data = {
  readonly id: string | null;
  readonly theme: {
    readonly themeKey: string | null;
  } | null;
  readonly " $fragmentType": "PageContentRenderer_space";
};
export type PageContentRenderer_space$key = {
  readonly " $data"?: PageContentRenderer_space$data;
  readonly " $fragmentSpreads": FragmentRefs<"PageContentRenderer_space">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "PageContentRenderer_space",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "Theme",
      "kind": "LinkedField",
      "name": "theme",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "themeKey"
        }
      ]
    }
  ],
  "type": "Space"
};

(node as any).hash = "107a7ff390a44ebbff249260c84e20e2";

export default node;
